import React from 'react'

import Google_Stories from '../assets/images/google-stories.png'
import google_stories_responsive from "../assets/images/google-stories-responsive.jpg"
import google_stories_video from "../assets/videos/google-stories-video.mp4"
import next_prev from "../assets/images/log-out.png"

import { motion } from 'framer-motion'
import ReactPlayer from 'react-player'
import "./Project.scss"
import { useNavigate } from 'react-router'


const content = (isFirstMount) => ({
    animate: {
        transition: { staggerChildren: 0.1, delayChildren: isFirstMount ? 2.8 : 0 },
    },
});

const title = {
    initial: { y: -20, opacity: 0 },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.7,
            ease: [0.6, -0.05, 0.01, 0.99],
        },
    },
};

export default function GoogleStories({ isFirstMount }) {

    let navigate = useNavigate();
    function handleClick() {
        navigate("/");
    }
    return (
        <motion.div exit={{ opacity: 0 }} className="individual_ones">
            {isFirstMount && <InitialTransition />}
            <motion.div
                initial="initial"
                animate="animate"
                variants={content(isFirstMount)}
                className="first6"
            >
                <section className="project_banner">
                    <div className="header">
                        <span className="" onClick={handleClick}>
                            Back To Main
                        </span>
                    </div>
                    <motion.div className="project_name"
                        variants={title}>
                        Google Stories
                    </motion.div>
                    <motion.div className="banner_image"
                        variants={title}>
                        <img src={Google_Stories} alt="Fakeflix Banner"
                            loading='lazy'
                        />
                    </motion.div>
                </section>
                <section className="project_description">
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            A streamlined clone of Google Stories
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Timeline
                            </div>
                            <div className="para_details">
                                September 2021 - October 2021
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Description
                            </div>
                            <div className="para_details">
                                <p>
                                    This is a simplified clone of the google stories (
                                    <a href="https://stories.google/">stories.google</a>) with
                                    subtle yet artfully smooth animations featuring the polished
                                    animation of video playing on the phone with other seperate
                                    animations that are linked to it.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Link
                            </div>
                            <div className="para_details">
                                <a href="https://google-stories.vercel.app/" target='_blank' rel='noreferrer'>
                                    google-stories.vercel.app
                                </a>
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Solution
                            </div>
                            <div className="para_details">
                                <p>
                                    The project is created in Gatsby framework and the main idea
                                    behind creating it was to learn more about mid-level interlinked
                                    scrolling animations that are created using GSAP and ScrollTrigger.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="demo_video">
                        <ReactPlayer
                            className='react-player fixed-bottom'
                            url={google_stories_video}
                            width='100%'
                            height='100%'
                            loop={true}
                            muted={true}
                            controls={false}
                            playing={true}
                        />
                    </div>
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            TYPOGAPHY
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Fugaz One
                            </div>
                            <div className="para_details">
                                Bold Heading Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: "Fugaz One, cursive" }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Product Sans
                            </div>
                            <div className="para_details">
                                Title Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: 'Product Sans' }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                system-ui (default font)
                            </div>
                            <div className="para_details">
                                Body Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only">
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "4vw" }}>
                        <div className="column title">
                            Color Swatches
                        </div>
                        <div className="column">
                            <div className="swatch_container">
                                <div className="swatch">
                                    <div className="bg_color" style={{ backgroundColor: "#285EDE" }}></div>
                                    <h3 className="color_code">#285EDE</h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color"
                                        style={{
                                            backgroundColor: "#000000",
                                            border: "1px solid whitesmoke"
                                        }}
                                    ></div>
                                    <h3 className="color_code">#000000</h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color" style={{ backgroundColor: "#222222" }}></div>
                                    <h3 className="color_code">#222222</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="project_footer">
                    <div className="responsive_image">
                        <img src={google_stories_responsive} alt=""
                            style={{ width: "100%", height: "100%" }}
                            loading='lazy'
                        />
                    </div>
                    <div className="other_projects">
                        <a href="/meadlight" className="prev_project">
                            <img src={next_prev} alt="previous project" className="rotate"
                                loading='lazy'
                            />
                            <span>Previous Project</span>
                        </a>
                        <a href="/cambrian" className="next_project">
                            <span>Next Project</span>
                            <img src={next_prev} alt="next project"
                                loading='lazy'
                            />
                        </a>
                    </div>
                </section>
            </motion.div>
        </motion.div>
    )
}





const blackBox = {
    initial: {
        height: "100vh",
        bottom: 0,
    },
    animate: {
        height: 0,
        transition: {
            when: "afterChildren",
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};

const textContainer = {
    initial: {
        opacity: 1,
        width: "100%"
    },
    animate: {
        opacity: 0,
        transition: {
            duration: 0.3,
            when: "afterChildren",
        },
    },
};

const text = {
    initial: {
        y: 40,
    },
    animate: {
        y: 80,
        transition: {
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};


const InitialTransition = () => {

    return (
        <motion.div
            className="first1"
            initial="initial"
            animate="animate"
            variants={blackBox}
            onAnimationStart={() => {
                document.body.classList.add("overflow-hidden")
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            onAnimationComplete={() => {
                document.body.classList.remove("overflow-hidden")
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
        >
            <motion.svg variants={textContainer} className="first2">
                <pattern
                    id="pattern"
                    patternUnits="userSpaceOnUse"
                    width={750}
                    height={800}
                    className="text-white"
                >
                    <rect className="first3" />
                    <motion.rect
                        variants={text}
                        className="first4"
                    />
                </pattern>
                <text
                    className="first5"
                    textAnchor="middle"
                    x="50%"
                    y="50%"
                    style={{ fill: "url(#pattern)" }}
                >
                    google stories
                </text>
            </motion.svg>
        </motion.div>
    );
};